<app-breadcrumb
  *ngIf="breadcrumbs$ | async as breadcrumbs"
  [backButton]="true"
  [title]="(item$ | async)?.title ?? ''"
  [items]="breadcrumbs"
></app-breadcrumb>
<app-skeleton
  *ngIf="!(isLoaded$ | async) && !(showError$ | async)"
></app-skeleton>
<nz-result
  *ngIf="(isLoaded$ | async) && (showError$ | async)"
  class="result-status-404"
  nzStatus="404"
  nzTitle="404"
  nzSubTitle="К сожалению, этой страницы нет на сайте"
>
  <div nz-result-extra>
    <a class="button button-primary" routerLink="/kb">Вернуться в раздел</a>
  </div></nz-result
>
<div class="section" *ngIf="item$ | async">
  <div class="section-content">
    <div class="grid">
      <div class="grid-item full-width">
        <div
          class="html-markup html-markup-l html-markup-strong-heading"
          [innerHTML]="(item$ | async)?.text ?? '' | safeHtml"
        ></div>
      </div>
    </div>
  </div>
</div>
